import React from 'react';

// ✅ Renamed to "Hero" to follow React component naming conventions
const Hero = () => {
  return (
    // Removed unused "text-black" class
    <div className='bg-gradient-to-r from-cyan-500 to-blue-500'>
      <div className='m-w-[800px] mt-[-96px] w-full h-screen mx-auto text-center flex flex-col justify-center'>
        <p className='text-white font-Poppins uppercase'>Creative professional who designs visual</p>
        <p className='text-white font-Poppins pb-2 uppercase'>content for print and digital media.</p>
        <h1 className='md:text-7xl sm:text-5xl text-6xl font-bold md:py-2'>i am andrew</h1>
      </div>
    </div>
  )
}

export default Hero;